import * as sx from '../../common/stylesInline/report_daily_branch'
import { useEffect, useState } from 'react'
import DropDownOA from '../../common/dropDownOA'
import moment from 'moment'
import { Item } from '../../common/snippets'
import {
  Box,
  Button,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Paper,
  TableContainer,
  FormControlLabel,
  Checkbox,
  TableHead,
} from '@mui/material'
import Datepicker from '../../common/datePicker'
import { getDateHeaders, getPastMonthHeaders } from '../../common/dateHelpers'
import { hexToRgb, navigation2, navigation3 } from '../../common/helper'
import ReactHtmlTableToExcel from 'react-html-table-to-excel'
import { analysisHeaders, orderList, rangeList, totalAmountGreaterThan, totalHeaders, viewTypeList } from './constants'
import { useAtom } from 'jotai'
import useToken from '../../helpers/useTokens'
import { GetRequestCachedV3, PostRequestCachedV3 } from '../../common/api'
import { API_CACHE_DURATION, dashBoard, monthNames, urls, xlCol, xlColq } from '../../common/constants'
import { alertAtom, globalLoaderAtom } from '../../common/jotaiState/globalStateAtoms'
import { devideInTwoIntegers, divideInNIntegers, safeAdd } from '../../common/mathHelper'
import { callAddFontRobotoMedium } from '../../common/font/Roboto-Medium-normal'
import { callAddFontRobotoBold } from '../../common/font/Roboto-bold'
import jsPDF from 'jspdf'
import autoTable from 'jspdf-autotable'
import { headColor } from './businessAnalysis'
import { useSearchParams } from 'react-router-dom'
import { CargoRoleRightsAtom, companySettingsAtom } from '../../common/jotaiState/commonStateAtoms'
import { ownBookingDetailedColumnsWithFormattedLRTwo } from '../Reports/BookingReports/BookingConstants'
import { ChildCompanyListData, fetchChildCompanyListData } from '../../common/jotaiState/reportStateAtom'

const reportname = 'Party Wise Booking Analysis'
export const PartyBusiness = () => {
  const { loginData } = useToken()
  const [, setSearchParams] = useSearchParams()
  const { intCompanyID, strCompanyName, intUserID, intBranchID } = { ...loginData }
  const [, setAlert] = useAtom(alertAtom)
  const [companySettings] = useAtom(companySettingsAtom)
  const [, fetchChildCompanyList] = useAtom(fetchChildCompanyListData)
  const [ChildCompanyList] = useAtom(ChildCompanyListData)
  const [selectCompany, setSelectedCompany] = useState({})
  const { UseFormattedLRinReports, DefaultCurrencyID, UseToPayAsCOD, BookingReportPortrait } = companySettings
  const headers = ownBookingDetailedColumnsWithFormattedLRTwo(UseFormattedLRinReports, DefaultCurrencyID, UseToPayAsCOD, intCompanyID, true)
  const [partyList, setPartyList] = useState([])
  const [party, setParty] = useState({})
  const [fromDate, setFromDate] = useState(moment().format('YYYY-MM-DD'))
  const [toDate, setToDate] = useState(moment().format('YYYY-MM-DD'))
  const [showResult, setShowResult] = useState(false)
  const [showTable, setShowTable] = useState(true)
  const [isRangeSelected, setIsRangeSelected] = useState(false)
  const [filteredData, setFilteredData] = useState([])
  const [tableHeaders, setTableHeaders] = useState([])
  const [viewType, setViewType] = useState(viewTypeList[0])
  const [range, setRange] = useState(rangeList[0])
  const [, setLoader] = useAtom(globalLoaderAtom)
  const [col1, col2] = devideInTwoIntegers(tableHeaders.length)
  const excelColspans = divideInNIntegers(tableHeaders.length, 4)
  const [sortByList, setSortByList] = useState([])
  const [sortBy, setSortBy] = useState(totalHeaders[0])
  const [order, setOrder] = useState(orderList[1])
  const [totalAmountGreaterThanValue, setTotalAmountGreaterThanValue] = useState({ name: 'All', id: 0 })
  const [rawList, setRawList] = useState([])
  const [branches, setBranches] = useState([])
  const [branch, setBranch] = useState({})
  const [userList, setUserList] = useState([])
  const [selectedUser, setSelectedUser] = useState()
  const [roleRights] = useAtom(CargoRoleRightsAtom)
  const RoleRights = roleRights?.Table1?.[0] || {}
  const { DashboardAccessLevel } = RoleRights || {}
  //const DashboardAccessLevel = 5
  const fetchOwnChildBranches = (data) => {
    setLoader(true)
    GetRequestCachedV3(urls.getOwnAndChildBranchList, data, true, API_CACHE_DURATION)
      .then((res) => {
        if (res.status !== 'Success') {
          throw new Error(res?.ErrMessage || 'Request Failed')
        }
        if (!Array.isArray(res.Data.Table) || res.Data.Table.length === 0) {
          throw new Error('No Data Found')
        }
        const branches = res.Data.Table
        setBranches(branches)
        const loginBranch = branches?.filter((item) => item.BranchID === intBranchID)
        setBranch(loginBranch?.[0])
      })
      .catch((err) => {
        setAlert({ show: true, msg: err.message, nextId: '' })
      })
      .finally(() => setLoader(false))
  }
  const handleBusinessAnalysis = async () => {
    if (!party.Party) {
      setAlert({ show: true, msg: 'Please select party', nextId: '' })
      return
    }
    const data = {
      intCompanyID: selectCompany?.CompanyID,
      PartyID: party.PartyID,
      FromDate: fromDate,
      ToDate: toDate,
      Mode: viewType.id,
      IsMonthWise: +isRangeSelected,
      Month: range.value,
      BranchID: branch?.BranchID || 0,
      UserID: selectedUser?.UserID || 0,
    }
    setLoader(true)
    const res = await GetRequestCachedV3(urls.getCargoPartyAnalysisData, data, true, API_CACHE_DURATION)
    setLoader(false)
    if (res.status === 'Success') {
      let dynamicHeaders = []
      if (isRangeSelected) {
        dynamicHeaders = getPastMonthHeaders(range.value).map((a) => ({
          name: `${a.month.toLocaleUpperCase()}-${a.year.toString().slice(-2)}`,
          field: `${a.month}-${a.year.toString().slice(-2)}`,
        }))
      } else {
        dynamicHeaders = getDateHeaders(new Date(fromDate), new Date(toDate)).map((a) => ({
          name: `${String(a.day).padStart(2, '0')}-${monthNames[a.month]}-${a.year.toString().slice(-2)}`,
          field: `${String(a.day).padStart(2, '0')}-${monthNames[a.month]}-${a.year.toString().slice(-2)}`,
        }))
      }
      setSortByList([...dynamicHeaders, ...totalHeaders])
      const headers = [...analysisHeaders, ...dynamicHeaders, ...totalHeaders]
      setRawList(res.Data.table)
      setTableHeaders(headers)
      makeTableRows(res.Data.table, headers, sortBy, order)
    } else {
      setAlert({ show: true, msg: res.ErrMessage, nextId: '' })
    }
  }
  const getUserList = (intBranchID, intCompanyID) => {
    let userBody = {
      intUserID: 0,
      intCompanyID,
      intBranchID,
      strUserName: '',
      strLoginID: '',
      strPassword: '',
      strContactNo: '',
      intRoleID: 0,
      intIsActive: 1,
    }
    setLoader(true)
    PostRequestCachedV3(urls.getUserList, userBody, true, API_CACHE_DURATION)
      .then((res) => {
        if (res.status !== 'Success' || !Array.isArray(res?.Data?.Table)) {
          throw new Error(res?.ErrMessage || 'Invalid Response')
        }

        if (!res.Data.Table.length) {
          throw new Error('No Data Found')
        }
        const list = [{ UserID: 0, UserName: 'ALL' }, ...res.Data.Table]
        setUserList(list)
        const defaultUser = list.find((a) => a.UserID === intUserID) || list[0]
        setSelectedUser(defaultUser)
      })
      .catch((err) => {
        setUserList([])
        setSelectedUser({ UserName: 'SELECT' })
        setAlert({
          show: true,
          msg: err.message,
          nextId: '',
        })
      })
      .finally(() => {
        setLoader(false)
      })
  }
  useEffect(() => {
    if (selectCompany?.CompanyID) {
      fetchOwnChildBranches({
        intUserID: 0,
        intCompanyID: selectCompany.CompanyID,
        intIsActive: 1,
      })
    }
  }, [selectCompany])
  useEffect(() => {
    const companyList = [{ CompanyID: intCompanyID, CompanyName: strCompanyName }]
    setSelectedCompany(companyList[0])
    const body = {
      intCompanyID: intCompanyID,
      UserID: intUserID,
    }
    fetchChildCompanyList(body)
  }, [intCompanyID])
  useEffect(() => {
    if (branch?.BranchID || branch?.BranchID === 0) {
      getUserList(branch.BranchID, selectCompany?.CompanyID || 0)
    }
  }, [branch])
  useEffect(() => {
    if (rawList.length) {
      makeTableRows(rawList, tableHeaders, sortBy, order)
    }
  }, [sortBy, order, totalAmountGreaterThanValue])
  const toNumber = (value) => {
    const num = Number(value)
    return Number.isFinite(num) ? num : 0
  }
  const applyThreshold = (rows) => {
    const threshold = toNumber(totalAmountGreaterThanValue?.id || 0)
    const filteredRows = threshold ? rows.filter((row) => row?.dataType !== 'entry' || toNumber(row.total || 0) > threshold) : rows
    let sn = 1
    return filteredRows.map((row) => {
      if (row?.dataType === 'header') {
        sn = 1
        return row
      }
      if (row?.dataType === 'entry') {
        return {
          ...row,
          sn: sn++,
        }
      }
      return row
    })
  }
  const recalculateTotalRow = (rows, headers) => {
    const totalIndex = rows
      .map((row, index) => ({ row, index }))
      .filter(({ row }) => row?.dataType === 'total')
      .pop()?.index
    if (totalIndex == null) return rows
    const nextRows = [...rows]
    const totalRow = { ...nextRows[totalIndex] }
    let grandTotal = 0
    headers.forEach((header) => {
      const field = header.field
      if (field !== 'sn' && field !== 'partyName' && field !== 'total') {
        const sum = nextRows.reduce((acc, row) => (row?.dataType === 'entry' ? safeAdd(acc, row[field] || 0) : acc), 0)
        totalRow[field] = sum
        grandTotal = safeAdd(grandTotal, sum)
      }
    })
    totalRow.total = grandTotal
    nextRows[totalIndex] = totalRow
    return nextRows
  }
  const makeTableRows = (list, headers, sortBy, order) => {
    const [col1, col2] = devideInTwoIntegers(headers.length)
    if (viewType.id === 1) {
      const { tableRows } = groupTableData(list, headers, 'TOTAL', sortBy?.field, order?.id)
      setFilteredData(recalculateTotalRow(applyThreshold(tableRows), headers))
    } else if (viewType.id === 2) {
      const groupedData = new Map()
      for (const item of list) {
        const id = item.BookingCityID
        if (!groupedData.has(id)) {
          groupedData.set(id, [])
        }
        groupedData.get(id).push(item)
      }
      let groupedRows = []
      const cumulativeTotalRow = {
        sn: 'TOTAL AMOUNT: ALL CITIES',
        partyName: '',
        colSpan: {
          sn: 2,
        },
        dataType: 'total',
      }
      for (const entries of groupedData.values()) {
        const row = {
          sn: `PARTY CITY: ${entries[0].CityName.toUpperCase()}`,
          dataType: 'subHeader',
          partyName: `   `,
          colSpan: {
            sn: headers.length - 1,
            partyName: 1,
          },
        }
        groupedRows.push(row)
        const { tableRows, totalRow } = groupTableData(
          entries,
          headers,
          `TOTAL: ${entries[0].CityName.toUpperCase()}`,
          sortBy?.field,
          order?.id
        )
        groupedRows.push(...tableRows)
        for (const key in totalRow) {
          if (['sn', 'partyName', 'colSpan', 'dataType'].includes(key)) continue
          const value = totalRow[key] || 0
          cumulativeTotalRow[key] = safeAdd(cumulativeTotalRow[key] || 0, value)
        }
      }
      groupedRows.push(cumulativeTotalRow)
      setFilteredData(recalculateTotalRow(applyThreshold(groupedRows), headers))
    }
    if (viewType.id === 3) {
      const groupedData = new Map()
      for (const item of list) {
        const cityId = item.BookingCityID
        if (!groupedData.has(cityId)) {
          groupedData.set(cityId, [])
        }
        groupedData.get(cityId).push(item)
      }
      let groupedRows = []
      const cumulativeTotalRow = {
        sn: 'TOTAL AMOUNT: ALL CITIES - ALL BRANCH',
        partyName: '',
        colSpan: { sn: 2 },
        dataType: 'total',
      }
      for (const cityEntries of groupedData.values()) {
        const cityName = cityEntries[0].CityName.toUpperCase()
        const branchGrouped = new Map()
        for (const entry of cityEntries) {
          const branchId = entry.BookingBranchID
          if (!branchGrouped.has(branchId)) {
            branchGrouped.set(branchId, [])
          }
          branchGrouped.get(branchId).push(entry)
        }
        const cityTotalRow = {
          sn: `TOTAL AMOUNT: ${cityName} - ALL BRANCH`,
          partyName: '',
          colSpan: { sn: 2 },
          dataType: 'total',
        }
        for (const branchEntries of branchGrouped.values()) {
          const branchName = branchEntries[0].BranchName.toUpperCase()
          groupedRows.push({
            sn: `PARTY CITY: ${cityName}`,
            dataType: 'subHeader',
            partyName: `PARTY BRANCH: ${branchName}`,
            colSpan: { sn: col2, partyName: col1 },
          })

          const { tableRows, totalRow } = groupTableData(
            branchEntries,
            headers,
            `TOTAL: ${cityName} - ${branchName}`,
            sortBy?.field,
            order?.id
          )
          groupedRows.push(...tableRows)
          for (const key in totalRow) {
            if (['sn', 'partyName', 'colSpan', 'dataType'].includes(key)) continue
            const value = totalRow[key] || 0
            cityTotalRow[key] = safeAdd(cityTotalRow[key] || 0, value)
          }
        }
        groupedRows.push(cityTotalRow)
        for (const key in cityTotalRow) {
          if (['sn', 'partyName', 'colSpan', 'dataType'].includes(key)) continue
          const value = cityTotalRow[key] || 0
          cumulativeTotalRow[key] = safeAdd(cumulativeTotalRow[key] || 0, value)
        }
      }
      groupedRows.push(cumulativeTotalRow)
      setFilteredData(recalculateTotalRow(applyThreshold(groupedRows), headers))
    }

    setShowResult(true)
    setShowTable(true)
  }
  const groupTableData = (data, headers, totalName = 'TOTAL', sortByKey, order) => {
    const groupedData = new Map()
    for (const item of data) {
      const id = item.sendingPartyID
      if (!groupedData.has(id)) {
        groupedData.set(id, [])
      }
      groupedData.get(id).push(item)
    }

    const tableRows = []
    let sn = 1
    const grandTotalRow = {
      sn: totalName,
      partyName: '',
      colSpan: {
        sn: 2,
      },
      dataType: 'total',
    }
    let grandTotal = 0
    const headerObject = headers.reduce(
      (acc, { field, name }) => {
        acc[field] = name
        return acc
      },
      { dataType: 'header' }
    )
    headers.forEach((header) => {
      const field = header.field

      if (field !== 'sn' && field !== 'partyName' && field !== 'total') {
        const sum = tableRows.reduce((acc, row) => safeAdd(acc, row[field] || 0), 0)
        grandTotalRow[field] = sum
        grandTotal = safeAdd(grandTotal, sum)
      }
    })
    for (const entries of groupedData.values()) {
      const row = {
        sn,
        partyName: entries[0].Party,
        sendingPartyID: entries[0].sendingPartyID,
        dataType: 'entry',
      }
      let total = 0
      headers.forEach((header) => {
        const field = header.field
        if (field !== 'sn' && field !== 'partyName' && field !== 'total') {
          const entry = entries.find((e) => field === e.MonthYear)
          const amount = entry?.Netamount || 0
          row[field] = amount
          total = safeAdd(total, amount)
        }
      })

      row.total = total
      tableRows.push(row)
      sn++
    }
    headers.forEach((header) => {
      const field = header.field

      if (field !== 'sn' && field !== 'partyName' && field !== 'total') {
        const sum = tableRows.reduce((acc, row) => safeAdd(acc, row[field] || 0), 0)
        grandTotalRow[field] = sum
        grandTotal = safeAdd(grandTotal, sum)
      }
    })
    grandTotalRow['total'] = grandTotal
    if (sortByKey && order) {
      tableRows.sort((a, b) => {
        const aValue = toNumber(a[sortByKey])
        const bValue = toNumber(b[sortByKey])
        if (order === 1) {
          return aValue - bValue
        } else {
          return bValue - aValue
        }
      })
      tableRows.forEach((row, index) => {
        row.sn = index + 1
      })
    }
    tableRows.push(grandTotalRow)
    tableRows.unshift(headerObject)
    return { tableRows, totalRow: grandTotalRow }
  }
  const printClick = (isSave = false) => {
    const HeaderColumns = tableHeaders.map((col) => {
      return {
        header: col.name,
        dataKey: col.field,
        xlCol: ['sn', 'partyName'].includes(col.field) ? xlCol : xlColq,
      }
    })
    jsPDF.API.events.push(['addFonts', callAddFontRobotoBold])
    jsPDF.API.events.push(['addFonts', callAddFontRobotoMedium])
    const doc = new jsPDF({ orientation: 'P', format: [1080, 1528], unit: 'px', compress: true })
    const pageSize = doc.internal.pageSize
    const pageWidth = pageSize.width || pageSize.getWidth()
    const pdfFontSize = pageWidth / (HeaderColumns.length > 11 ? 1122 : 793)
    doc.setProperties({
      title: `${reportname}.pdf`,
      subject: reportname,
      author: 'Maven Tech Labs Pvt. Ltd.',
      keywords: 'maven tech, Cargo system, Branch Business',
      creator: 'MTLPL',
    })
    autoTable(doc, {
      margin: { top: 60, left: 30, right: 30, bottom: 5 },
      alternateRowStyles: {
        fillColor: [255, 255, 255],
      },
      showHead: 'never',
      columns: HeaderColumns,
      columnStyles: {},
      theme: 'grid',
      startY: 120,
      body: filteredData,

      willDrawCell: (data) => {
        doc.setTextColor(0, 0, 0)
        data.cell.styles.valign = 'middle'
        doc.setFontSize(pdfFontSize * 14).setFont('Roboto', 'normal')
        const rowType = data.row.raw.dataType
        const hexColor = headColor[rowType]
        if (hexColor) {
          const rgb = hexToRgb(hexColor)
          doc.setFillColor(...rgb)
        } else {
          doc.setFillColor(255, 255, 255)
        }
      },

      didParseCell: (data) => {
        const colDef = data.column.raw
        const colSpanMap = data?.row?.raw?.colSpan || {}
        if (colDef.xlCol?.dataType === 'string') {
          data.cell.styles.halign = 'left'
        } else if (colDef.xlCol?.dataType === 'quantity') {
          data.cell.styles.halign = 'right'
        } else {
          data.cell.styles.halign = 'center'
        }
        if (data.row.raw.dataType === 'total' && data.column.dataKey === 'sn') {
          data.cell.colSpan = 2
        }
        if (data.row.raw.dataType === 'subHeader') {
          if (data.column.dataKey === 'sn') {
            if (!!data.row.raw.partyName.trim()) {
              data.cell.colSpan = colSpanMap.sn
            } else {
              data.cell.colSpan = colSpanMap.sn + 1
            }
          }
          const currentIndex = data.column.index
          if (currentIndex === colSpanMap.sn && colSpanMap.partyName) {
            const sourceContent = data.row.raw.partyName
            data.cell.text = sourceContent
            data.cell.colSpan = colSpanMap.partyName
            data.cell.styles.halign = 'left'
          }
        }
      },
      didDrawPage: (data) => {
        doc.addImage('/images/logo-66.png', 'JPEG', 30, 50, 50, 50)
        doc.setFontSize(pdfFontSize * 20).setFont('Roboto', 'bold')
        doc.setTextColor(16, 79, 162)
        doc.text(`Cargo System | ${reportname}`, 90, 80)

        doc.setTextColor(0, 0, 0)
        doc.text(`Company Name : ${loginData.strCompanyName}`, doc.internal.pageSize.width - data.settings.margin.left, 80, 'right')
      },
    })
    setShowTable(false)
    setTimeout(() => {
      setLoader(false)
      document.getElementById('branchBusinessPdf').data = doc.output('datauristring', 'Branch Business.pdf')
    }, 2000)
    if (isSave) {
      doc.save(`Branch Business ${new Date().getTime()}.pdf`)
    }
  }
  const handleGo = async () => {
    try {
      const data = {
        intCompanyID: selectCompany?.CompanyID,
        PartyID: 0,
        FromDate: fromDate,
        ToDate: toDate,
        Mode: 0,
        IsMonthWise: +isRangeSelected,
        Month: range.value,
        BranchID: branch?.BranchID || 0,
        UserID: selectedUser?.UserID || 0,
      }
      setLoader(true)
      const res = await GetRequestCachedV3(urls.getCargoPartyAnalysisData, data, true, API_CACHE_DURATION)
      setLoader(false)
      if (res.status === 'Success') {
        const partyList = res.Data.table.map((a) => ({
          PartyID: a.sendingPartyID,
          Party: a.Party,
        }))
        if (partyList.length > 1) {
          partyList.unshift({ PartyID: 0, Party: 'All' })
        }
        setParty(partyList?.[0] || {})
        setPartyList(partyList)
      } else {
        setAlert({ show: true, msg: res.ErrMessage, nextId: '' })
      }
    } catch (error) {}
  }
  const goToDashBoard = () => {
    setSearchParams({ view: dashBoard })
  }
  const getMonthDateRange = (value) => {
    const [month, year] = value.split('-')

    const monthIndex = monthNames.indexOf(month)

    const fullYear = `20${year}`

    const firstDay = `${fullYear}-${String(monthIndex + 1).padStart(2, '0')}-01`

    const lastDate = new Date(fullYear, monthIndex + 1, 0).getDate()

    const lastDay = `${fullYear}-${String(monthIndex + 1).padStart(2, '0')}-${lastDate}`

    return {
      startDate: firstDay,
      endDate: lastDay,
    }
  }
  const getMonthDateRange2 = (value) => {
    const [date, month, year] = value.split('-')
    const monthIndex = monthNames.indexOf(month)
    const fullYear = `20${year}`
    const firstDay = `${fullYear}-${String(monthIndex + 1).padStart(2, '0')}-${date}`
    const lastDay = `${fullYear}-${String(monthIndex + 1).padStart(2, '0')}-${date}`
    return {
      startDate: firstDay,
      endDate: lastDay,
    }
  }
  const criteriaHeaders = [
    { field: 'selCompany', header: 'Selected Company', textAlign: 'left' },
    { field: 'fromDate', header: 'From Booking Date', textAlign: 'left' },
    { field: 'toDate', header: 'To Booking  Date', textAlign: 'left' },
    { field: 'sourceCity', header: 'Source City', textAlign: 'left' },
    { field: 'sourceBranch', header: 'Source Branch', textAlign: 'left' },
    { field: 'sourceBranchUser', header: 'Source Branch User', textAlign: 'left' },
    { field: 'destinationCity', header: 'Destination City', textAlign: 'left' },
    { field: 'destinationBranch', header: 'Destination Branch', textAlign: 'left' },
    { field: 'paymentType', header: 'Payment Type', textAlign: 'left' },
    { field: 'transactionType', header: 'TransactionType', textAlign: 'left' },
    { field: 'selReportView', header: 'Report View`', textAlign: 'left' },
  ]
  const transform = (list) =>
    list.map((val, i) => ({
      ...val,
      srNo: i + 1,
      dataType: 'entry',
      DstCityBranch: `${val.DestCityName}\n${val.DestBranchName}`,
      BkgDtTimeBy: `${moment(val.BkgDtTime).format('DD-MMM-YY HH:mm')}\n${val.UserBooked}`,
      'Sender^^SenderGSTN': `${val.Sender}\n${val.SenderGSTN}`,
      'SourceCityName^^SourceBranchName': `${val.SourceCityName}\n${val.SourceBranchName}`,
      'SenderMobileNo^^SenderEmailID': `${val.SenderMobileNo}\n${val.SenderEmailID}`,
      'RecMobileNo^^ReceiverEmailID': `${val.RecMobileNo}\n${val.ReceiverEmailID}`,
      'RecName^^RecGSTN': `${val.RecName}\n${val.RecGSTN}`,
      'BkgDtTime^^UserBooked': `${moment(val.BkgDtTime).format('DD-MMM-YY HH:mm')}\n${val.UserBooked}`,
      'LRNO^^ManualLRNo': val.LRNO + '\n' + val.ManualLRNo,
      'DestCityName^^DestBranchName': val.DestCityName + '\n' + val.DestBranchName,
      'ConsignmentType^^Quantity': val.ConsignmentType + '\n' + val.Quantity,
      BookedResponse: val.BookedResponse ? JSON.parse(val.BookedResponse)?.TransID : '',
      DeliveredResponse: val.DeliveredResponse ? JSON.parse(val.DeliveredResponse)?.TransID : '',
    }))

  const summarize = (list) =>
    list.reduce(
      (acc, val) => {
        acc.Quantity += +val.Quantity || 0
        acc.Freight += +val.Freight || 0
        acc.CartageAmount += +val.CartageAmount || 0
        acc.HamaliCharges += +val.HamaliCharges || 0
        acc.DocumentCharges += +val.DocumentCharges || 0
        acc.Valuation += +val.Valuation || 0
        acc.OtherCharges += +val.OtherCharges || 0
        acc.BookingGST += +val.BookingGST || 0
        acc.NetAmount += +val.NetAmount || 0
        return acc
      },
      {
        Quantity: 0,
        Freight: 0,
        CartageAmount: 0,
        HamaliCharges: 0,
        DocumentCharges: 0,
        Valuation: 0,
        OtherCharges: 0,
        BookingGST: 0,
        NetAmount: 0,
      }
    )
  const groupData = (arr = [], headers) => {
    const lengths = divideInNIntegers(headers.length, 3)
    let index = 0
    const pickedHeaders = []
    lengths.forEach((span) => {
      pickedHeaders.push(headers[index].field)
      index += span
    })
    const headerRow = headers.reduce(
      (acc, col) => {
        acc[col.field] = col.header
        return acc
      },
      { dataType: 'header' }
    )

    const grouped = {}

    // Step 1: Group by IsRefund and PaymentMode
    arr = arr.map((v, i) => ({
      ...v,
      Valuation: Math.round(v.Valuation) || 0,
      CartageAmount: Math.round(v.CartageAmount) || 0,
    }))
    arr.forEach((val) => {
      const key = `${val.IsRefund}-${val.PaymentMode}`
      if (!grouped[key]) grouped[key] = []
      grouped[key].push(val)
    })

    const finalData = []
    const grandTotal = {
      Quantity: 0,
      Freight: 0,
      CartageAmount: 0,
      HamaliCharges: 0,
      DocumentCharges: 0,
      Valuation: 0,
      OtherCharges: 0,
      BookingGST: 0,
      NetAmount: 0,
    }

    const groupedEntries = Object.entries(grouped)

    groupedEntries.forEach(([key, list]) => {
      const [isRefund, paymentMode] = key.split('-')
      const transformed = transform(list)
      const summary = summarize(transformed)

      Object.keys(grandTotal).forEach((k) => {
        grandTotal[k] += summary[k] || 0
      })
      finalData.push({
        colSpan: Object.fromEntries(pickedHeaders.map((key, i) => [key, lengths[i] || 1])),
        align: { [pickedHeaders[0]]: 'left', [pickedHeaders[1]]: 'center', [pickedHeaders[2]]: 'right' },
        [pickedHeaders[0]]: `Source City :All`,
        [pickedHeaders[1]]: `Destination City:All`,
        [pickedHeaders[2]]: `Trans: ${isRefund === '0' ? 'Booked' : 'Refund'} | Payment Mode: ${paymentMode}`,
        dataType: 'subHeader',
        totalSubKey: 3,
      })
      finalData.push({ ...headerRow })
      finalData.push(...transformed)
      Object.keys(summary).forEach((k) => {
        summary[k] = Number(summary[k].toFixed(2))
      })
      finalData.push({
        ...summary,
        'ConsignmentType^^Quantity': summary.Quantity,
        colSpan: { [pickedHeaders[0]]: headers.findIndex((header) => header.field === 'ConsignmentType^^Quantity') },
        [pickedHeaders[0]]: `Total: Src.City All / Dest.City All, Trans:All | PaymentMode: ${paymentMode}`,
        dataType: 'total',
        align: { [pickedHeaders[0]]: 'right' },
        IsRefund: Number(isRefund),
      })
    })
    if (Object.keys(grouped).length > 1) {
      Object.keys(grandTotal).forEach((k) => {
        grandTotal[k] = Number(grandTotal[k].toFixed(2))
      })
      finalData.push({
        ...grandTotal,
        'ConsignmentType^^Quantity': grandTotal.Quantity,
        align: { [pickedHeaders[0]]: 'right' },
        colSpan: { [pickedHeaders[0]]: headers.findIndex((header) => header.field === 'ConsignmentType^^Quantity') },
        [pickedHeaders[0]]: `Net Total: Src.City All Cities / Dest.City All Cities, Trans: Booked + Refund`,
        dataType: 'total',
        IsRefund: 0,
      })
    }
    if (finalData.length === 0) {
      const noData = [
        {
          [headers[0].field]: 'No results found. Please refine your search parameters and search again.',
          dataType: 'total',
          colSpan: { [headers[0].field]: headers.length },
          align: { [headers[0].field]: 'center' },
        },
      ]
      return noData
    }
    return finalData
  }
  const criteriaData = {
    selCompany: loginData.strCompanyNamee || '',
    fromDate: fromDate || '',
    toDate: toDate || '',
    sourceCity: 'All',
    sourceBranch: 'All',
    sourceBranchUser: 'All',
    destinationCity: 'All',
    destinationBranch: 'All',
    paymentType: 'All',
    transactionType: 'All',
    selReportView: 'Detailed',
    dataType: 'entry',
  }
  const handleCellClick = (item, field) => {
    if (item.dataType === 'entry' && item[field] && !['sn', 'partyName'].includes(field)) {
      const data = {
        CompanyID: selectCompany?.CompanyID,
        SourceCityID: 0,
        SourceBranchID: 0,
        DateFrom: 0,
        DateTo: 0,
        LoggedInUser: intUserID,
        // MobileNo: '',
        // SenderName: '',
        p_PartyID: item.sendingPartyID,
        p_Month: 0,
        AllowViewAllReport: 1,
      }
      if (field === 'total') {
        data.DateFrom = fromDate
        data.DateTo = toDate
        if (isRangeSelected) {
          data.p_Month = range.value
        }
      } else {
        const { startDate, endDate } = isRangeSelected ? getMonthDateRange(field) : getMonthDateRange2(field)
        data.DateFrom = startDate
        data.DateTo = endDate
      }
      setLoader(true)
      GetRequestCachedV3(urls.DashBoardBookingReport, data)
        .then((res) => {
          if (res.status !== 'Success') {
            throw new Error(res?.ErrMessage || 'Request Failed')
          }
          if (!Array.isArray(res.Data.Table) || res.Data.Table.length === 0) {
            throw new Error('No Data Found')
          }
          const updatedData = res.Data.Table.map((item) => ({
            ...item,
            PayType: UseToPayAsCOD === 1 && item.PaymentTypeID === 2 ? 'COD' : item.PaymentTypeID === 7 ? 'COD(MANUAL)' : item.PayType,
            STATUS:
              DefaultCurrencyID === 2
                ? item.STATUS === 'BRANCH RECEIVED'
                  ? 'Sc. Tr. Receive'
                  : item.STATUS?.replace('DELIVERY RECEIVED', ' Assign Delivery').replace('Out Delivered', 'Pending Out Delivery')
                : item.STATUS,
          }))

          const finalData = groupData(updatedData, headers)
          let mainHeader = headers
            .filter((obj) => obj.isSelected)
            ?.map((val) => ({
              ...val,
              align: val.headerSx.textAlign,
              export: val.exportHead,
              weight: 80,
            }))
          let manageColIdValue = ''
          if (BookingReportPortrait === 1) {
            manageColIdValue = 'ownBookingDetailedColumnsPotrate'
          } else if (DefaultCurrencyID === 2) {
            manageColIdValue = 'ownBookingLeymaDetailedColumns21'
          } else {
            manageColIdValue = 'ownBookingDetailedColumns223'
          }
          const reportPayload = {
            reportName: 'Own Booking Report',
            criteriaHeaders: criteriaHeaders,
            criteriaData: [criteriaData],
            tableData: finalData,
            mainHeader: mainHeader,
            isShowManageColumn: true,
            manageColumnID: manageColIdValue,
            colSpanMarker: 'STATUS',
            hideHeader: true,
            serialNokey: 'srNo',
            showColumnBorders: true,
            totalSubKey: 3,
            isIncreFontSize: true,
          }
          const rid = Date.now().toString()

          if (!window.generatedReports) {
            window.generatedReports = {}
          }

          window.generatedReports[rid] = reportPayload

          window.open(`/view-report?rid=${rid}`, '_blank')
        })
        .catch((err) => {
          setAlert({ show: true, msg: err.message, nextId: '' })
        })
        .finally(() => setLoader(false))
    }
  }
  return (
    <Item className="dashboard" sx={{ padding: '0' }}>
      <Item sx={{ padding: '0' }} className="dashboard-controls">
        <Box sx={sx.reportFlex} style={{ background: '#fff', borderBottom: '1px solid #ccc', paddingBottom: '10px' }}>
          <Item sx={{ ...sx.itemsx }} className="dashboard-branch">
            <DropDownOA
              id=""
              label={'Select Company'}
              data={ChildCompanyList}
              width="100%"
              defaultvalue={selectCompany?.CompanyName || ''}
              dataKey={'CompanyName'}
              idKey={'CompanyID'}
              listWidth={'280px'}
              disabled={DashboardAccessLevel < 5}
              onSelect={setSelectedCompany}
            />
          </Item>
          <Item sx={{ ...sx.itemsx }} className="dashboard-branch">
            <DropDownOA
              id="selectBranch"
              label={'Select Branch'}
              defaultvalue={branch?.BranchName || ''}
              onSelect={(val) => {
                setBranch(val)
              }}
              dataKey={'BranchName'}
              idKey={'BranchID'}
              data={[{ BranchID: 0, BranchName: 'All Branches' }, ...branches]}
              width="100%"
              listWidth={'280px'}
              disabled={DashboardAccessLevel < 2}
            />
          </Item>
          <Item sx={{ ...sx.itemsx }} className="dashboard-branch">
            <DropDownOA
              id=""
              label={'Select User'}
              data={userList}
              listWidth={'280px'}
              defaultvalue={selectedUser?.UserName || ''}
              dataKey={`UserName`}
              idKey={`UserID`}
              width="100%"
              onSelect={setSelectedUser}
              disabled={DashboardAccessLevel < 1}
            />
          </Item>
          <Item sx={sx.itemsx} className="input--container bookingDatePicker">
            <Datepicker
              name={'from_date'}
              label={`From Date`}
              id="fromDate"
              dateChange={(date) => {
                setFromDate(moment(date).format('YYYY-MM-DD'))
              }}
              startDate={'2024-01-01'}
              endDate={toDate}
              width="100%"
              statusChecked={isRangeSelected}
            />
          </Item>
          <Item sx={sx.itemsx} className="input--container bookingDatePicker">
            <Datepicker
              name={'to_date'}
              label={`To Date`}
              id="toDate"
              dateChange={(date) => {
                setToDate(moment(date).format('YYYY-MM-DD'))
              }}
              startDate={fromDate}
              endDate={moment().format('YYYY-MM-DD')}
              width="100%"
              statusChecked={isRangeSelected}
            />
          </Item>
          <FormControlLabel
            sx={{ margin: '0 -10px' }}
            control={
              <Checkbox
                id="exempted-checkbox"
                checked={isRangeSelected}
                onChange={(e) => setIsRangeSelected(e.target.checked)}
                onKeyDown={(e) => navigation2(e, '', '')}
              />
            }
            label=""
          />
          <Item sx={{ ...sx.itemsx }} className="dashboard-branch">
            <DropDownOA
              label={'Select Range (Last)'}
              defaultvalue={range?.name || ''}
              data={rangeList}
              idKey="value"
              dataKey="name"
              onSelect={(e) => setRange(e)}
              disabled={!isRangeSelected}
            />
          </Item>

          <Item id="generateDiv" tabIndex={0} sx={sx.itemsx}>
            <Button
              id="showDashBoard"
              variant="contained"
              className="btn btn-primary"
              autoFocus={false}
              onClick={handleGo}
              sx={{
                width: '100%',
                letterSpacing: '2px',
                height: '40px',
              }}
            >
              GO
            </Button>
          </Item>
          <Item sx={{ ...sx.itemsx }} className="dashboard-branch">
            <DropDownOA
              label={'Select Party Name'}
              data={partyList}
              defaultvalue={party?.Party || ''}
              idKey="PartyID"
              dataKey="Party"
              onSelect={(e) => setParty(e)}
            />
          </Item>
          <Item sx={{ ...sx.itemsx }} className="dashboard-branch">
            <DropDownOA
              label={'Analysis view'}
              defaultvalue={viewType?.name || ''}
              data={viewTypeList}
              idKey="id"
              dataKey="name"
              onSelect={(e) => setViewType(e)}
            />
          </Item>

          <Item id="" tabIndex={0} sx={sx.itemsx}>
            <Button
              id=""
              variant="contained"
              className="btn btn-primary"
              autoFocus={false}
              onClick={handleBusinessAnalysis}
              sx={{
                width: '100%',
                letterSpacing: '2px',
                height: '40px',
              }}
            >
              Load
            </Button>
          </Item>
          <Item id="" tabIndex={0} sx={sx.itemsx}>
            <Button
              id=""
              variant="contained"
              className="btn btn-primary"
              autoFocus={false}
              onClick={goToDashBoard}
              sx={{
                width: '100%',
                letterSpacing: '2px',
                height: '40px',
              }}
            >
              Dashboard
            </Button>
          </Item>
        </Box>
      </Item>
      {showResult && (
        <Item className="dashboard-body2" sx={{ padding: '10px 15px', boxShadow: 'none' }}>
          <Box className="userReport" sx={{ display: 'flex', width: '100%', height: '40px', padding: '12px 0', marginRight: 0 }}>
            <Box sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', gap: '12px', fontSize: '14px' }}>
              <h3 style={{ textAlign: 'left', color: '#444', paddingLeft: '16px' }}>Report For: {reportname}</h3>
            </Box>

            <Box
              className="userReport-buttons"
              sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', paddingRight: '16px' }}
            >
              <Item sx={{ ...sx.itemsx }} className="dashboard-branch">
                <DropDownOA
                  label={'Sort By'}
                  defaultvalue={sortBy?.name || ''}
                  data={sortByList}
                  idKey="field"
                  dataKey="name"
                  onSelect={(e) => setSortBy(e)}
                />
              </Item>
              <Item sx={{ ...sx.itemsx }} className="dashboard-branch">
                <DropDownOA
                  label={'Order'}
                  defaultvalue={order?.name || ''}
                  data={orderList}
                  idKey="id"
                  dataKey="name"
                  onSelect={(e) => setOrder(e)}
                />
              </Item>
              <Item sx={{ ...sx.itemsx }} className="dashboard-branch">
                <DropDownOA
                  label={'Filter By Amount'}
                  defaultvalue={totalAmountGreaterThanValue?.name || ''}
                  data={totalAmountGreaterThan}
                  idKey="id"
                  dataKey="name"
                  onSelect={(e) => setTotalAmountGreaterThanValue(e)}
                />
              </Item>
              {showTable ? (
                <>
                  <Box onKeyDown={(e) => navigation3(e, 'creditSummaryPdfBtn', '', () => {})}>
                    <ReactHtmlTableToExcel
                      id="creditSummaryExcelBtn"
                      className="userWisereporttemExcelBtn"
                      table="partyBusinessTable-Excel"
                      filename={`${reportname} ${new Date().getMilliseconds()}`}
                      sheet="tablexls"
                      buttonText="Export to Excel"
                    />
                  </Box>

                  <Box>
                    <Button
                      variant="outlined"
                      id="creditSummaryPdfBtn"
                      onKeyDown={(e) => navigation3(e, 'creditSummaryPrintBtn', 'creditSummaryExcelBtn', () => printClick(true))}
                      className="userWisereporttembtn"
                      onClick={() => printClick(true)}
                      disabled={!isRangeSelected}
                    >
                      Export to Pdf
                    </Button>
                  </Box>

                  <Box>
                    <Button
                      variant="outlined"
                      id="creditSummaryPrintBtn"
                      onKeyDown={(e) => navigation3(e, '', 'creditSummaryPdfBtn', () => printClick(false))}
                      className="userWisereporttembtn"
                      onClick={() => printClick(false)}
                      disabled={!isRangeSelected}
                    >
                      Print
                    </Button>
                  </Box>
                </>
              ) : (
                <Box>
                  <Button
                    id="backBtn"
                    variant="outlined"
                    className="userWisereporttembtn"
                    onClick={() => setShowTable(true)}
                    onKeyDown={(e) => navigation3(e, '', '', () => setShowTable(true))}
                  >
                    Back
                  </Button>
                </Box>
              )}
            </Box>
          </Box>
          {showTable ? (
            <Box sx={{ marginTop: '16px' }}>
              <TableContainer component={Paper} className="scrollBlue" sx={{ maxHeight: '60vh', marginBottom: '5px' }}>
                <Table
                  stickyHeader
                  size="small"
                  aria-label="a dense table"
                  sx={{
                    '& .MuiTableCell-root': {
                      padding: '6px',
                      color: '#444',
                      lineHeight: 1,
                    },
                  }}
                >
                  <TableBody className="filter-data-row-BorderNone" sx={{ border: 'none !important' }}>
                    {filteredData.length ? (
                      <>
                        {filteredData.map((item, index) => {
                          const colSpans = item?.colSpan || {}
                          console.log(item)
                          return (
                            <TableRow key={index + 'efsdjxwi3'}>
                              {tableHeaders.map((col, index) =>
                                (col.field === 'partyName' && item.dataType === 'total') ||
                                (item.dataType === 'subHeader' && !['sn', 'partyName'].includes(col.field)) ? (
                                  <> </>
                                ) : (
                                  <TableCell
                                    key={`Tsswwd0454wwH-${index}`}
                                    colSpan={colSpans[col.field] || 1}
                                    onClick={() => handleCellClick(item, col.field)}
                                    sx={{
                                      backgroundColor: headColor[item.dataType],
                                      height: '36px',
                                      fontSize: '13px',
                                      color:
                                        !item[col.field] && item.dataType === 'entry'
                                          ? '#FF0000 !important'
                                          : !['sn', 'partyName'].includes(col.field) && item[col.field] && item.dataType === 'entry'
                                            ? '#1976d2 !important'
                                            : '#000',
                                      fontWeight: item.dataType === 'entry' ? 600 : 700,
                                      textAlign: ['sn', 'partyName'].includes(col.field) ? 'left' : 'right',
                                      textDecoration:
                                        !['sn', 'partyName'].includes(col.field) && item[col.field] && item.dataType === 'entry'
                                          ? 'underline'
                                          : 'none',
                                    }}
                                  >
                                    {item[col.field] || 0}
                                  </TableCell>
                                )
                              )}
                            </TableRow>
                          )
                        })}
                      </>
                    ) : (
                      <TableRow>
                        <TableCell colSpan={tableHeaders.length}>
                          <Box
                            sx={{
                              display: 'flex',
                              justifyContent: 'center',
                              mt: 2,
                              mb: 2,
                              color: 'red',
                              fontSize: '14px',
                            }}
                          >
                            No results found. Please refine your search parameters and search again.
                          </Box>
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          ) : (
            <object
              id="branchBusinessPdf"
              type="application/pdf"
              width={'100%'}
              height="440"
              title="MTLPL -Cargo System - Branch Business"
              aria-label="MTLPL -Cargo System - Branch Business"
              style={{ marginTop: '10px', textAlign: 'center' }}
            ></object>
          )}
          <Box sx={{ marginTop: '16px', display: 'none' }}>
            <TableContainer component={Paper} className="scrollBlue" sx={{ maxHeight: '60vh', marginBottom: '5px' }}>
              <Table
                stickyHeader
                size="small"
                id="partyBusinessTable-Excel"
                aria-label="a dense table"
                sx={{
                  '& .MuiTableCell-root': {
                    padding: '6px',
                    color: '#444',
                    lineHeight: 1,
                  },
                }}
              >
                <TableHead style={{ fontWeight: 'bold', position: 'sticky', top: '0' }}>
                  <TableRow>
                    <TableCell
                      className="reportTD"
                      style={{ fontWeight: 'bold', fontSize: '24px', fontWeight: '500', textAlign: 'left' }}
                      colSpan={col2}
                    >
                      <h3 style={{ paddingLeft: '17px' }}>Report For: {reportname}</h3>
                    </TableCell>
                    <TableCell
                      className="reportTD"
                      style={{ fontWeight: 'bold', fontSize: '24px', fontWeight: '500', textAlign: 'right' }}
                      colSpan={col1}
                    >
                      <h3 style={{ paddingLeft: '17px' }}>Company Name :{loginData.strCompanyName}</h3>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell colSpan={tableHeaders.length}></TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell
                      className="ReportItemHead"
                      style={{
                        backgroundColor: '#bfe1ff',
                        color: '#454646',
                        fontSize: '20px',
                        fontWeight: '600',
                        textAlign: 'left',
                      }}
                      colSpan={excelColspans[2]}
                    >
                      From Date
                    </TableCell>
                    <TableCell
                      className="ReportItemHead"
                      style={{
                        backgroundColor: '#bfe1ff',
                        color: '#454646',
                        fontSize: '20px',
                        fontWeight: '600',
                        textAlign: 'left',
                      }}
                      colSpan={excelColspans[3]}
                    >
                      To Date
                    </TableCell>
                    <TableCell
                      className="ReportItemHead"
                      style={{
                        backgroundColor: '#bfe1ff',
                        color: '#454646',
                        fontSize: '20px',
                        fontWeight: '600',
                        textAlign: 'left',
                      }}
                      colSpan={excelColspans[0]}
                    >
                      Selected Party
                    </TableCell>
                    <TableCell
                      className="ReportItemHead"
                      style={{
                        backgroundColor: '#bfe1ff',
                        color: '#454646',
                        fontSize: '20px',
                        fontWeight: '600',
                        textAlign: 'left',
                      }}
                      colSpan={excelColspans[1]}
                    >
                      Analysis View
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell
                      className="ReportItemHead"
                      style={{
                        color: '#454646',
                        fontSize: '20px',
                        fontWeight: '600',
                        textAlign: 'left',
                      }}
                      colSpan={excelColspans[2]}
                    >
                      {fromDate}
                    </TableCell>
                    <TableCell
                      className="ReportItemHead"
                      style={{
                        color: '#454646',
                        fontSize: '20px',
                        fontWeight: '600',
                        textAlign: 'left',
                      }}
                      colSpan={excelColspans[3]}
                    >
                      {toDate}
                    </TableCell>
                    <TableCell
                      className="ReportItemHead"
                      style={{
                        color: '#454646',
                        fontSize: '20px',
                        fontWeight: '600',
                        textAlign: 'left',
                      }}
                      colSpan={excelColspans[0]}
                    >
                      {party?.Party || ''}
                    </TableCell>
                    <TableCell
                      className="ReportItemHead"
                      style={{
                        color: '#454646',
                        fontSize: '20px',
                        fontWeight: '600',
                        textAlign: 'left',
                      }}
                      colSpan={excelColspans[1]}
                    >
                      {viewType?.name || ''}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell colSpan={tableHeaders.length}></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody className="filter-data-row-BorderNone" sx={{ border: 'none !important' }}>
                  {filteredData.length ? (
                    <>
                      {filteredData.map((item, index) => {
                        const colSpans = item?.colSpan || {}
                        return (
                          <TableRow key={index + 'dfwfdd4gf40df'}>
                            {tableHeaders.map((col, index) =>
                              (col.field === 'partyName' && item.dataType === 'total') ||
                              (item.dataType === 'subHeader' && !['sn', 'partyName'].includes(col.field)) ? (
                                <> </>
                              ) : (
                                <TableCell
                                  key={`Tssdfw32wwwwH-${index}`}
                                  colSpan={colSpans[col.field] || 1}
                                  style={{
                                    backgroundColor: headColor[item.dataType],
                                    color: '#454646',
                                    fontSize: '20px',
                                    fontWeight: '600',
                                    textAlign: ['sn', 'partyName'].includes(col.field) ? 'left' : 'right',
                                  }}
                                >
                                  {item[col.field] || 0}
                                </TableCell>
                              )
                            )}
                          </TableRow>
                        )
                      })}
                    </>
                  ) : (
                    <TableRow>
                      <TableCell colSpan={tableHeaders.length}>
                        <Box
                          sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            mt: 2,
                            mb: 2,
                            color: 'red',
                            fontSize: '14px',
                          }}
                        >
                          No results found. Please refine your search parameters and search again.
                        </Box>
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </Item>
      )}
    </Item>
  )
}
